module.exports = __webpack_public_path__ + "img/leumi-small.f6474ebe.svg";